import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function CaseDetail2Page() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const processSteps = [
    {
      title: '前期規劃會議',
      time: '搬遷前 7 天',
      description: '與公司負責人討論搬遷時程、設備清單、網路配置需求',
      image: 'https://public.readdy.ai/ai/img_res/bbaf0e5b33c90877cc4155d3b79c9143.jpg'
    },
    {
      title: 'IT 設備盤點',
      time: '搬遷前 3 天',
      description: '詳細記錄所有電腦、伺服器、網路設備，標記線路配置',
      image: 'https://readdy.ai/api/search-image?query=IT%20technician%20documenting%20computer%20equipment%20and%20servers%20in%20Taiwan%20tech%20company%20office%2C%20organized%20cable%20labeling%20and%20inventory%20checklist%2C%20professional%20equipment%20assessment%2C%20modern%20office%20technology%20setup&width=800&height=600&seq=case-detail-2-step2&orientation=landscape'
    },
    {
      title: '專業打包作業',
      time: '搬遷前 1 天',
      description: '使用防靜電包裝材料保護電子設備，文件分類裝箱',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carefully%20packing%20office%20computers%20and%20monitors%20with%20anti-static%20materials%20in%20Taiwan%20corporate%20office%2C%20organized%20labeled%20boxes%20for%20documents%20and%20equipment%2C%20systematic%20office%20packing%20process&width=800&height=600&seq=case-detail-2-step3&orientation=landscape'
    },
    {
      title: '設備安全搬運',
      time: '搬遷當天上午',
      description: '專業團隊使用推車和保護設備，安全搬運所有辦公設備',
      image: 'https://readdy.ai/api/search-image?query=Professional%20moving%20team%20transporting%20office%20furniture%20and%20IT%20equipment%20with%20specialized%20dollies%20in%20Taiwan%20office%20building%2C%20coordinated%20teamwork%20moving%20desks%20and%20chairs%2C%20safe%20commercial%20relocation%20process&width=800&height=600&seq=case-detail-2-step4&orientation=landscape'
    },
    {
      title: '新辦公室配置',
      time: '搬遷當天下午',
      description: '按照新辦公室平面圖擺放家具，協助設備定位',
      image: 'https://readdy.ai/api/search-image?query=Workers%20arranging%20office%20furniture%20and%20workstations%20in%20new%20Taiwan%20corporate%20office%20space%2C%20organized%20desk%20placement%20according%20to%20floor%20plan%2C%20modern%20open%20office%20layout%20setup%2C%20professional%20office%20configuration&width=800&height=600&seq=case-detail-2-step5&orientation=landscape'
    },
    {
      title: '系統測試驗收',
      time: '搬遷當天傍晚',
      description: '協助連接設備，確認所有電腦和網路正常運作',
      image: 'https://readdy.ai/api/search-image?query=IT%20team%20testing%20computer%20systems%20and%20network%20connections%20in%20newly%20relocated%20Taiwan%20office%2C%20employees%20checking%20workstations%2C%20successful%20office%20relocation%20completion%2C%20modern%20tech%20company%20workspace&width=800&height=600&seq=case-detail-2-step6&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg 
        type="review" 
        data={{
          reviewRating: 5,
          reviewAuthor: '劉總經理',
          reviewDate: '2024-02-10',
          reviewText: '科技公司搬遷最怕設備損壞，建鈞搬家團隊非常專業，所有設備都安全送達，完全不影響公司運作。'
        }}
      />

      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-emerald-600 to-teal-600 overflow-hidden">
        <div className="absolute inset-0 bg-pattern opacity-10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 text-emerald-100 mb-6">
            <Link to="/cases" className="hover:text-white transition-colors flex items-center gap-2">
              <i className="ri-arrow-left-line"></i>
              <span>返回案例列表</span>
            </Link>
            <span>/</span>
            <span className="text-white">案例詳情</span>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-building-line"></i>
                <span>辦公室搬遷</span>
              </div>

              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                台北信義區科技公司搬遷
              </h1>

              <p className="text-xl text-emerald-100 mb-8 leading-relaxed">
                50坪科技公司從信義區舊辦公室搬到內湖科技園區，包含20台電腦、2台伺服器、大量辦公家具。我們在48小時內完成搬遷，確保週一正常營運。
              </p>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-emerald-100 text-sm mb-1">客戶名稱</div>
                  <div className="text-white text-lg font-semibold">創新科技股份有限公司</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-emerald-100 text-sm mb-1">搬遷地點</div>
                  <div className="text-white text-lg font-semibold">信義區 → 內湖區</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-emerald-100 text-sm mb-1">辦公室坪數</div>
                  <div className="text-white text-lg font-semibold">50 坪</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-emerald-100 text-sm mb-1">搬遷費用</div>
                  <div className="text-white text-lg font-semibold">$35,000</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-emerald-400 to-teal-400 rounded-3xl blur-2xl opacity-30"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20technology%20company%20office%20interior%20in%20Taipei%20Taiwan%20with%20computer%20workstations%20and%20professional%20IT%20equipment%2C%20organized%20open%20office%20space%20with%20contemporary%20furniture%2C%20bright%20corporate%20environment%20ready%20for%20business%20operations&width=800&height=600&seq=case-detail-2-hero&orientation=landscape"
                alt="台北信義區科技公司搬遷"
                className="relative rounded-3xl shadow-2xl w-full h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 客戶評價 */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8 md:p-12 shadow-lg">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full flex items-center justify-center text-white text-3xl font-bold shadow-lg">
                劉
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900">劉總經理</div>
                <div className="text-gray-600">創新科技股份有限公司</div>
                <div className="flex items-center gap-2 mt-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                  ))}
                  <span className="text-gray-600 font-semibold ml-2">5.0 分</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="flex items-start gap-3">
                <i className="ri-double-quotes-l text-emerald-600 text-4xl flex-shrink-0"></i>
                <div className="flex-1">
                  <p className="text-gray-700 text-lg leading-relaxed mb-4">
                    科技公司搬遷最怕設備損壞和資料遺失，建鈞搬家團隊非常專業！他們事前做了詳細的設備盤點和線路標記，搬運過程也特別小心。
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    最讓我驚訝的是，週五下班後開始搬，週一早上所有同事就能正常上班了。20台電腦、2台伺服器全部正常運作，完全沒有影響公司營運。這樣的效率和專業度，真的很值得推薦！
                  </p>
                </div>
                <i className="ri-double-quotes-r text-emerald-600 text-4xl flex-shrink-0"></i>
              </div>
            </div>

            <div className="mt-6 flex items-center justify-between text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line"></i>
                <span>2024年2月10日</span>
              </div>
              <div className="bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full font-semibold">
                企業客戶
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 搬家過程 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">完整搬遷流程</h2>
            <p className="text-xl text-gray-600">專業規劃，確保企業營運不中斷</p>
          </div>

          <div className="space-y-16">
            {processSteps.map((step, index) => (
              <div key={index} className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="relative">
                    <div className="absolute -top-6 -left-6 w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">
                      {index + 1}
                    </div>
                    <img
                      src={step.image}
                      alt={step.title}
                      className="rounded-3xl shadow-2xl w-full h-96 object-cover object-top"
                    />
                  </div>
                </div>

                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                    <i className="ri-time-line"></i>
                    <span>{step.time}</span>
                  </div>

                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed">{step.description}</p>

                  <div className="mt-6 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6">
                    <div className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-emerald-600 text-2xl flex-shrink-0 mt-1"></i>
                      <div>
                        <div className="font-semibold text-gray-900 mb-2">專業服務重點</div>
                        <ul className="space-y-2 text-gray-700">
                          {index === 0 && (
                            <>
                              <li>• 確認搬遷時程避開營業高峰</li>
                              <li>• 規劃新辦公室座位配置</li>
                              <li>• 協調大樓管理處搬運時段</li>
                            </>
                          )}
                          {index === 1 && (
                            <>
                              <li>• 建立完整設備清單</li>
                              <li>• 標記所有網路線和電源線</li>
                              <li>• 備份重要資料確保安全</li>
                            </>
                          )}
                          {index === 2 && (
                            <>
                              <li>• 防靜電包裝保護電子設備</li>
                              <li>• 文件依部門分類裝箱</li>
                              <li>• 貴重設備特殊保護處理</li>
                            </>
                          )}
                          {index === 3 && (
                            <>
                              <li>• 專業推車搬運大型設備</li>
                              <li>• 電梯專用時段避免等待</li>
                              <li>• 伺服器專人專車運送</li>
                            </>
                          )}
                          {index === 4 && (
                            <>
                              <li>• 按平面圖精準定位</li>
                              <li>• 組裝辦公桌椅和隔板</li>
                              <li>• 協助調整最佳工作動線</li>
                            </>
                          )}
                          {index === 5 && (
                            <>
                              <li>• 協助連接電腦和網路</li>
                              <li>• 測試所有設備正常運作</li>
                              <li>• 清理包裝材料和垃圾</li>
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 辦公室搬遷實拍 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-camera-line"></i>
              <span>真實記錄</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">辦公室搬遷實拍照片</h2>
            <p className="text-xl text-gray-600">專業企業搬遷，確保營運不中斷</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=IT%20technician%20labeling%20computer%20cables%20and%20network%20wires%20with%20colored%20tags%20in%20Taiwan%20office%2C%20organized%20cable%20management%20before%20office%20relocation&width=400&height=400&seq=case2-real-1&orientation=squarish"
                alt="網路線標記"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">網路線標記</p>
                  <p className="text-white/80 text-sm">色標分類方便重新配置</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Desktop%20computers%20and%20monitors%20being%20wrapped%20with%20anti-static%20bubble%20wrap%20in%20Taiwan%20corporate%20office%2C%20professional%20IT%20equipment%20packing%20for%20relocation&width=400&height=400&seq=case2-real-2&orientation=squarish"
                alt="電腦防靜電包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">電腦防靜電包裝</p>
                  <p className="text-white/80 text-sm">專業材料保護電子設備</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Server%20rack%20being%20carefully%20moved%20with%20specialized%20equipment%20in%20Taiwan%20data%20center%2C%20professional%20server%20relocation%20with%20protective%20measures&width=400&height=400&seq=case2-real-3&orientation=squarish"
                alt="伺服器搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">伺服器搬運</p>
                  <p className="text-white/80 text-sm">專業設備安全運送</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Office%20documents%20and%20files%20organized%20in%20labeled%20archive%20boxes%20in%20Taiwan%20corporate%20office%2C%20systematic%20document%20packing%20by%20department&width=400&height=400&seq=case2-real-4&orientation=squarish"
                alt="文件分類裝箱"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">文件分類裝箱</p>
                  <p className="text-white/80 text-sm">依部門分類便於歸位</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Office%20desk%20being%20disassembled%20with%20professional%20tools%20in%20Taiwan%20workplace%2C%20organized%20furniture%20dismantling%20with%20labeled%20parts&width=400&height=400&seq=case2-real-5&orientation=squarish"
                alt="辦公桌拆卸"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">辦公桌拆卸</p>
                  <p className="text-white/80 text-sm">專業工具快速拆裝</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Movers%20loading%20office%20chairs%20and%20equipment%20into%20elevator%20in%20Taiwan%20commercial%20building%2C%20coordinated%20office%20moving%20team&width=400&height=400&seq=case2-real-6&orientation=squarish"
                alt="電梯搬運作業"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">電梯搬運作業</p>
                  <p className="text-white/80 text-sm">預約專用時段提高效率</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=New%20office%20workstations%20being%20set%20up%20with%20computers%20and%20monitors%20in%20modern%20Taiwan%20office%20space%2C%20organized%20desk%20arrangement&width=400&height=400&seq=case2-real-7&orientation=squarish"
                alt="新辦公室配置"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">新辦公室配置</p>
                  <p className="text-white/80 text-sm">按平面圖精準定位</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=IT%20staff%20connecting%20network%20cables%20and%20testing%20computer%20systems%20in%20newly%20relocated%20Taiwan%20office%2C%20system%20verification%20after%20move&width=400&height=400&seq=case2-real-8&orientation=squarish"
                alt="系統測試驗收"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">系統測試驗收</p>
                  <p className="text-white/80 text-sm">確認所有設備正常運作</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 grid md:grid-cols-4 gap-6">
            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-computer-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">IT 設備保護</h3>
              <p className="text-gray-600 text-sm">防靜電包裝，設備零損傷</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">48 小時完成</h3>
              <p className="text-gray-600 text-sm">週末搬遷，週一正常營運</p>
            </div>
            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-wifi-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">網路配置</h3>
              <p className="text-gray-600 text-sm">協助重新配置網路連線</p>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-checkbox-circle-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">系統驗收</h3>
              <p className="text-gray-600 text-sm">測試確認所有設備正常</p>
            </div>
          </div>
        </div>
      </section>

      {/* Google 客戶評論照片 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-google-fill"></i>
              <span>Google 評論</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">企業客戶分享的真實照片</h2>
            <p className="text-xl text-gray-600">來自 Google 地圖評論的辦公室搬遷紀錄</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20photo%20of%20IT%20equipment%20being%20carefully%20packed%20with%20anti-static%20materials%20in%20Taiwan%20office%2C%20real%20Google%20review%20image%20of%20professional%20office%20moving&width=400&height=400&seq=google-review-2-1&orientation=squarish"
                alt="客戶分享 - IT設備包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">創新科技分享</p>
                  <p className="text-white/80 text-xs">電腦包裝很專業</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20showing%20organized%20office%20documents%20in%20labeled%20boxes%20during%20corporate%20relocation%20in%20Taiwan%2C%20authentic%20business%20moving%20review&width=400&height=400&seq=google-review-2-2&orientation=squarish"
                alt="客戶分享 - 文件整理"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">數位行銷公司分享</p>
                  <p className="text-white/80 text-xs">文件分類很清楚</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20customer%20review%20photo%20of%20server%20rack%20being%20moved%20with%20specialized%20equipment%20in%20Taiwan%20data%20center%2C%20real%20professional%20IT%20relocation%20service&width=400&height=400&seq=google-review-2-3&orientation=squarish"
                alt="客戶分享 - 伺服器搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">軟體開發公司分享</p>
                  <p className="text-white/80 text-xs">伺服器搬運零故障</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20shared%20photo%20of%20new%20office%20workstations%20being%20set%20up%20after%20relocation%20in%20Taiwan%20business%20district%2C%20real%20Google%20review%20of%20office%20moving%20completion&width=400&height=400&seq=google-review-2-4&orientation=squarish"
                alt="客戶分享 - 新辦公室配置"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">會計事務所分享</p>
                  <p className="text-white/80 text-xs">配置效率很高</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20photo%20from%20business%20customer%20showing%20movers%20disassembling%20office%20cubicles%20in%20Taiwan%20corporate%20office%2C%20authentic%20commercial%20moving%20documentation&width=400&height=400&seq=google-review-2-5&orientation=squarish"
                alt="客戶分享 - 隔板拆卸"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">貿易公司分享</p>
                  <p className="text-white/80 text-xs">隔板拆裝很專業</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20review%20photo%20showing%20conference%20room%20furniture%20being%20moved%20in%20Taiwan%20office%20building%2C%20real%20professional%20office%20relocation%20service%20documentation&width=400&height=400&seq=google-review-2-6&orientation=squarish"
                alt="客戶分享 - 會議室搬遷"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">設計公司分享</p>
                  <p className="text-white/80 text-xs">會議桌搬運很穩</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20Google%20review%20photo%20of%20moving%20team%20working%20efficiently%20in%20Taiwan%20office%20building%20lobby%2C%20real%20customer%20documentation%20of%20professional%20service&width=400&height=400&seq=google-review-2-7&orientation=squarish"
                alt="客戶分享 - 團隊作業"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">廣告公司分享</p>
                  <p className="text-white/80 text-xs">團隊分工明確</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20of%20completed%20modern%20office%20space%20after%20professional%20relocation%20in%20Taiwan%20business%20center%2C%20satisfied%20corporate%20client%20review&width=400&height=400&seq=google-review-2-8&orientation=squarish"
                alt="客戶分享 - 搬遷完成"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">科技新創分享</p>
                  <p className="text-white/80 text-xs">週一準時開工</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-8 mt-8">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-google-fill text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">企業客戶好評</div>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                      ))}
                    </div>
                    <span className="text-gray-600 font-semibold">5.0 滿分推薦</span>
                  </div>
                </div>
              </div>
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-emerald-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-emerald-700 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                <span>查看更多評論</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 搬家挑戰與解決方案 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">搬遷挑戰與解決方案</h2>
            <p className="text-xl text-gray-600">專業團隊，克服企業搬遷難題</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center">
                  <i className="ri-alert-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">搬遷挑戰</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">必須在週末完成搬遷</div>
                      <p className="text-gray-600 text-sm">不能影響週一正常營運，時間壓力大</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">伺服器設備價值高</div>
                      <p className="text-gray-600 text-sm">2台伺服器價值超過百萬，不能有任何損傷</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">新舊大樓距離遠</div>
                      <p className="text-gray-600 text-sm">從信義區到內湖區，車程約30分鐘</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">網路配置複雜</div>
                      <p className="text-gray-600 text-sm">20個工作站的網路線需要重新配置</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-lightbulb-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">解決方案</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-emerald-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">安排 6 位專業人員輪班</div>
                      <p className="text-gray-600 text-sm">週五晚間到週日，48小時不間斷作業</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-emerald-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">伺服器專車專人運送</div>
                      <p className="text-gray-600 text-sm">恆溫車廂、防震設備、全程監控</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-emerald-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">使用 2 台大型搬運車</div>
                      <p className="text-gray-600 text-sm">減少往返次數，提高搬運效率</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-emerald-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">事前標記所有線路</div>
                      <p className="text-gray-600 text-sm">拍照記錄、編號標籤，快速重新配置</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 bg-gradient-to-br from-emerald-600 to-teal-600 rounded-3xl p-8 text-center shadow-2xl">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-trophy-line text-yellow-300 text-4xl"></i>
              <h3 className="text-3xl font-bold text-white">搬遷成果</h3>
            </div>
            <p className="text-xl text-emerald-100 leading-relaxed max-w-3xl mx-auto">
              週五下午5點開始搬遷，週日下午3點全部完成。週一早上9點，所有員工準時上班，20台電腦、2台伺服器全部正常運作，網路連線穩定，完全沒有影響公司營運。客戶非常滿意我們的效率和專業！
            </p>
          </div>
        </div>
      </section>

      {/* 服務項目 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">本次提供的服務</h2>
            <p className="text-xl text-gray-600">企業搬遷全方位解決方案</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-computer-line text-emerald-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">IT 設備搬運</h3>
              <p className="text-gray-600 text-center text-sm">電腦、伺服器專業搬運，防靜電保護</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-archive-line text-teal-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">文件打包</h3>
              <p className="text-gray-600 text-center text-sm">依部門分類裝箱，方便快速歸位</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-tools-line text-emerald-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">家具拆裝</h3>
              <p className="text-gray-600 text-center text-sm">辦公桌椅、隔板專業拆裝組合</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-wifi-line text-teal-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">網路配置</h3>
              <p className="text-gray-600 text-center text-sm">協助網路線路重新配置連接</p>
            </div>
          </div>
        </div>
      </section>

      {/* 更多案例 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">查看更多成功案例</h2>
            <p className="text-xl text-gray-600">每個案例都是我們的承諾</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <Link to="/case-detail-1" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20three%20bedroom%20apartment%20interior%20in%20Taiwan%20with%20organized%20furniture%20and%20moving%20boxes%2C%20professional%20moving%20service%20in%20progress%2C%20clean%20bright%20family%20living%20space&width=600&height=400&seq=more-case-office-1&orientation=landscape"
                    alt="家庭搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    家庭搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">
                    新北板橋 3 房家庭搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">35坪家庭，鋼琴搬運零損傷</p>
                </div>
              </div>
            </Link>

            <Link to="/case-detail-3" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cozy%20studio%20apartment%20with%20organized%20personal%20belongings%20in%20New%20Taipei%20Taiwan%2C%20compact%20living%20space%20moving%20service%2C%20efficient%20packing%20for%20young%20professional&width=600&height=400&seq=more-case-office-2&orientation=landscape"
                    alt="套房搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    套房搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">
                    新北新莊套房搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">8坪套房，全套打包服務</p>
                </div>
              </div>
            </Link>

            <Link to="/case-detail-4" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Long%20distance%20moving%20truck%20on%20Taiwan%20highway%20with%20professional%20logistics%2C%20cross-city%20relocation%20service%2C%20secure%20cargo%20transport&width=600&height=400&seq=more-case-office-3&orientation=landscape"
                    alt="跨縣市搬家"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    長途搬家
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">
                    桃園中壢跨縣市搬家
                  </h3>
                  <p className="text-gray-600 text-sm">30坪家庭，一天完成搬遷</p>
                </div>
              </div>
            </Link>
          </div>

          <div className="text-center">
            <Link
              to="/cases"
              className="inline-flex items-center gap-2 bg-emerald-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-emerald-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
            >
              <span>查看所有案例</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-3xl shadow-2xl p-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">企業搬遷找建鈞</h2>
            <p className="text-xl text-gray-600 mb-8">
              專業規劃、高效執行，確保營運不中斷
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/quote"
                className="bg-emerald-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-emerald-700 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg flex items-center justify-center gap-2"
              >
                <i className="ri-calculator-line text-xl"></i>
                <span>線上免費估價</span>
              </Link>

              <a
                href="tel:0978900081"
                className="bg-white border-2 border-emerald-600 text-emerald-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-emerald-50 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>0978-900-081</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
